// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"01f3532e","455":"1f73fdb8","977":"8fb22af5"}[chunkId] + ".chunk.js";
};